<template>
  <a-layout-footer class="hm-web-footer">
    <!-- ** ---------- PC Start ---------- ** -->
    <div class="trial show-pc" :style="trialStyle" v-if="!ifTrial">
      <hm-img imgClass="logo-slogan-img" type="images" imgName="logo/logo_slogan_pc_zh" align="center" />
      <p>联系我们，获取专业解决方案</p>
      <div class="tryout-box">
        <a-input class="input" placeholder="请填写您的手机号码" v-model.trim="form.phoneNo"/>
        <a-input v-model.trim="form.verificationCode" placeholder="请填写验证码"  class="input">
          <a slot="suffix" :loading="codeLoading || countDown !== 0" @click="onSendVerifyCode">
            {{ countDown === 0 ? '获取验证码' : `重新获取(${countDown})` }}
          </a>
        </a-input>
        <a-input class="company-input" placeholder="请填写您的企业名称" v-model.trim="form.enterpriseName"/>
        <a-button class="trial-button" @click.stop="submit">申请试用</a-button>
        <div class="privacy">
          <a-checkbox v-model="agreement">
            我已阅读并同意
            <a href="#" class="link" @click.stop.prevent="toPrivacy">《华盟隐私政策》</a>
          </a-checkbox>
        </div>
      </div>
    </div>
    <div class="footer show-pc">
      <div class="w1200 content">
        <div class="left">
          <div @click.stop="clickRouter('/home')" style="cursor: pointer;">
            <hm-img type="images" imgName="logo/footer_logo_01_zh" />
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div class="navigation" v-for="(item) in linkList" :key="item.key">
              <div class="h1" @click.stop="clickRouter(item.path)">{{item.title}}</div>
              <!-- :class="{ ulCase: index === 2 }" -->
              <ul>
                <li v-for="li in item.children" :key="li.key" @click.stop="clickRouter(li.path)" class="li">{{li.label}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w1200 content_footer" v-if="false">
        <div class="linkimg">
          <div class="imgwrap1">
            <div class="img1">
              <hm-img type="images" imgName="footer_icon_02_zh" imgClass="footer_icon" />
            </div>
            <div class="img3">
              <hm-img type="images" imgName="footer_icon_09_zh" imgClass="footer_icon" />
            </div>
            <div class="code1">
              <hm-img type="images" imgName="footer_icon_12_zh" />
            </div>
          </div>
          <div class="imgwrap2">
            <div class="img2">
              <hm-img type="images" imgName="footer_icon_01_zh" imgClass="footer_icon" />
            </div>
            <div class="img4">
              <hm-img type="images" imgName="footer_icon_10_zh" imgClass="footer_icon" />
            </div>
            <div class="code2">
              <hm-img type="images" imgName="footer_icon_11_zh" />
            </div>
          </div>
        </div>
        <div class="componay_msg">
          <div class="address">
            华盟科技咨询（深圳）有限公司 <br>
            咨询电话：4006288680 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;渠道加盟：18923830202<br>
            公司地址：深圳市南山区粤海街道高新区社区高新南七道17号数字技术园A1栋五层
          </div>
          <div class="componay_photo">
            <hm-img type="images" imgName="reward" imgClass="componay_horn_img" />
            <!-- <div class="componay_photo_item" v-for="item in 5" :key="item">
              <hm-img type="images" :imgName="`footer_icon_0${item + 2}_zh`" :imgClass="`footer_icon_0${item + 2}`" />
              <div style="color: #607296;">{{componay_photo_list[item]}}</div>
            </div> -->
          </div>
        </div>
      </div>
      <a-divider class="line" />
      <div class="copyright">
        <!-- <hm-img type="images" imgName="footer_icon_08_zh" imgClass="footer_marking" /> -->
        <div class="footer_marking">
          <a href=" " target="_blank" style="position: relative;height: 40PX;">
            <div style="width:100%;height:100%;position: absolute;top: -30PX;left: 0;height: 50PX;"></div>
            <embed src="https://program.xinchacha.com/cre/2022032350544567840.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a >

          <a href="https://xyt.xcc.cn/getpcInfo?sn=1504019638390816768&language=CN&certType=8&url=*.huamengtech.com" target="_blank" style="position: relative;left: 16PX;height: 50PX;">
            <div style="width:100%;height:100%;position: absolute;top: -30PX;left: 0;height: 50PX;"></div>
            <embed src="https://program.xinchacha.com/web/1504019638390816768=*.huamengtech.com.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a>
        </div>
        <!-- <div style="margin-left: 10PX;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009921" style="display:inline-block;text-decoration:none;">
            <img src="@/assets/images/footer_beian_01_zh.png" style="float:left;"/>
            <p style="float:left;height:20PX;line-height:20PX;margin: 0PX 0PX 0PX 5PX; color:#939393;">粤公网安备 44030502009921号</p>
          </a>
        </div> -->
        <div>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030502009921" target="_blank" style="color: #848D9E;">粤公网安备 44030502009921号</a> | Copyright © 2019-2023 华盟科技咨询（深圳）有限公司   |   <a href="https://beian.miit.gov.cn" target="_blank" style="color: #848D9E;">粤ICP备2021035314号</a>
        </div>
        <div class="linkimg">
          <div class="imgwrap1">
            <div class="img1">
              <hm-img type="images" imgName="footer_icon_02_zh" imgClass="footer_icon" />
            </div>
            <div class="img3">
              <hm-img type="images" imgName="footer_icon_09_zh" imgClass="footer_icon" />
            </div>
            <div class="code1">
              <hm-img type="images" imgName="footer_icon_12_zh" />
            </div>
          </div>
          <div class="imgwrap2">
            <div class="img2">
              <hm-img type="images" imgName="footer_icon_01_zh" imgClass="footer_icon" />
            </div>
            <div class="img4">
              <hm-img type="images" imgName="footer_icon_10_zh" imgClass="footer_icon" />
            </div>
            <div class="code2">
              <hm-img type="images" imgName="footer_icon_11_zh" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ** ---------- PC End ---------- ** -->

    <!-- ** ---------- H5 Start ---------- ** -->
    <div class="trial-h5 show-h5 w750" :style="h5TrialStyle" v-if="!h5IfTrial">
      <!-- <div class="msg">
        <hm-img imgClass="logo" type="images" imgName="logo/footer_logo_01_zh" />
        <p>智慧税务综合管理平台</p>
      </div>
      <div class="btn">
        <a-button class="button" @click.stop="gotoTryout">欢迎试用</a-button>
      </div> -->
      <hm-img imgClass="logo-slogan-img" type="images" imgName="logo/logo_slogan_h5_zh" align="center" />
      <a-button class="trial-button" @click.stop="gotoTryout">欢迎试用</a-button>
    </div>
    <div class="footer-h5 w750 show-h5">
      <!-- <div class="content">
        <div class="item">
          <div class="navigation" v-for="(item, index) in linkList" :key="item.key">
            <div class="h1" @click.stop="clickRouter(item.path)">{{item.title}}</div>
            <a-divider class="line" />
            <ul class="ul">
              <li v-for="li in item.children" :key="li.key" @click.stop="clickRouter(li.path)" class="li">{{li.label}}</li>
            </ul>
          </div>
        </div>
      </div>
      <a-divider class="line" /> -->
      <div class="componay_msg">
        <div class="top">
          <hm-img type="images" imgName="footer_logo_01_zh" imgClass="footer_logo_01" />
          <div class="name">
            <div>华盟科技咨询（深圳）有限公司</div>
          </div>
        </div>
         <!-- <div class="msg">
          <div class="text">
            联系电话：<span @click="callNum('4006288680')">4006288680</span>
            <span style="margin-left: 40px;">渠道加盟：</span><span @click="callNum('18923830202')">18923830202</span>
          </div>
         <div class="text">
            公司地址：深圳市南山区粤海街道高新区社区高新南七道17号数字技术园A1栋5层
          </div>
        </div> -->
      </div>
      <div class="code_list">
        <div class="item" style="margin-right: 4rem;">
          <hm-img type="images" imgName="footer_h5icon_01_zh" imgClass="footer_h5icon_code" />
          <div style="margin-top: 1.2rem;">华盟小助手</div>
        </div>
        <div class="item">
          <hm-img type="images" imgName="footer_h5icon_02_zh" imgClass="footer_h5icon_code"  />
          <div style="margin-top: 1.2rem;">税纪云公众号</div>
        </div>
      </div>
      <a-divider class="line" />
      <div class="componay_photo" v-if="false">
        <hm-img type="images" imgName="footer_componay_01_zh" imgClass="footer_componay_01_zh" />
      </div>
      <div class="componay_text">
        Copyright © 2019-2023 <br>
        华盟财税咨询（深圳）有限公司 <br>
        粤ICP备19162135号
      </div>
      <div style="text-align: center;margin-bottom: 16px;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009921" style="display:inline-block;text-decoration:none;">
          <img src="@/assets/images/footer_beian_01_zh.png" style="float:left;"/>
          <p style="float:left;height:20PX;line-height:20PX;margin: 0PX 0PX 0PX 5PX; color:#939393;">粤公网安备 44030502009921号</p>
        </a>
      </div>
      <div class="copyright">
        <!-- <hm-img type="images" imgName="footer_icon_08_zh" imgClass="footer_marking" /> -->
        <div class="footer_marking">
          <a href=" " target="_blank" style="position: relative;height: 40PX;">
            <div style="width:100%;height:100%;position: absolute;top: -30PX;left: 0;height: 50PX;"></div>
            <embed src="https://program.xinchacha.com/cre/2022032350544567840.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a >
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1504019638390816768&language=CN&certType=8&url=*.huamengtech.com" target="_blank" style="position: relative;left: 16PX;height: 50PX;">
            <div style="width:100%;height:100%;position: absolute;top: -30PX;left: 0;height: 50PX;"></div>
            <embed src="https://program.xinchacha.com/web/1504019638390816768=*.huamengtech.com.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a>
        </div>
      </div>
    </div>
    <!-- ** ---------- H5 End ---------- ** -->
  </a-layout-footer>
</template>

<script>
import { isPoneAvailable } from '@/utils/tools'

import { linkList } from './data.js'
import { GetSendVerificationCode, PostProbationQuestions } from '@/api/api'

export default {
  name: 'hm-web-footer',
  data () {
    return {
      linkList,
      trialStyle: {
        backgroundImage: 'url(' + require('@/assets/images/footer_trial_03_zh.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom'
      },
      h5TrialStyle: {
        backgroundImage: 'url(' + require('@/assets/images/tryOut_h5bg_02_zh.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 20rem'
      },
      componay_photo_list: {
        1: '公安等保三级',
        2: 'ISO管理体系认证',
        3: 'CMMI3权威认证',
        4: 'SAP认证合作伙伴',
        5: '双软认证'
      },
      form: {
        phoneNo: '', // 手机号
        verificationCode: '', // 验证码
        enterpriseName: '', // 企业名称
        name: '', // 客户名
        remark: '', // 留言
        dataSource: '官网' // 数据来源
      },
      agreement: false,
      codeLoading: false,
      countDownTimer: null,
      countDown: 0,
      showLabel: ['phoneNo', 'verificationCode', 'enterpriseName']
    }
  },
  mounted () {
    console.log(this.$route)
  },
  computed: {
    ifTrial () {
      return this.$route.name === 'tryOut'
    },
    h5IfTrial () {
      return this.$route.name === 'tryOut' || this.$route.name === 'home' || this.$route.name === 'invite-job' || this.$route.name === 'hm-style'
    }
  },
  methods: {
    clickRouter (path) {
      console.log('%c点击logo', 'background-color: green;color: #fff;', path)
      if (path) this.$router.push(path)
    },
    gotoTryout () {
      this.$router.push({ name: 'tryOut' })
    },
    callNum (num) {
      window.location.href = 'tel://' + num
    },
    async onSendVerifyCode () {
      console.log('%c发送验证码', 'background-color: green;color: #fff;', isPoneAvailable(this.form.phoneNo))
      if (this.codeLoading) return
      if (this.form.phoneNo === '' || !isPoneAvailable(this.form.phoneNo)) {
        this.$message.warning('请填写正确格式的手机号码')
        return
      }
      await this.genVerifyCode()
      this.countDownStart()
    },
    genVerifyCode () {
      return new Promise((resolve, reject) => {
        this.codeLoading = true
        GetSendVerificationCode({ phoneNo: this.form.phoneNo }).then(res => {
          console.log('%c获取验证码', 'background-color: green;color: #fff;', res)
          if (res && res.code === '200') {
            this.$message.success('发送成功')
            this.codeLoading = false
            resolve()
          }
        }, err => {
          reject(err)
          this.codeLoading = false
        })
      })
    },
    async submit () {
      const ifValid = this.verifyForm()
      console.log('%c提交', 'background-color: green;color: #fff;', this.form, ifValid)
      if (!ifValid) return
      await this.onApply()
      this.$emit('on-success')
    },
    onApply () {
      return new Promise((resolve, reject) => {
        PostProbationQuestions(this.form).then(res => {
          console.log('%c申请试用', 'background-color: green;color: #fff;', res)
          if (res.code === '200') {
            this.$message.success('提交成功, 稍后会有客服与你联系')
            resolve()
          } else {
            this.$message.error(res.msg)
            reject(new Error(res.msg))
          }
        })
      })
    },
    verifyForm () {
      let flag = true
      for (let key of this.showLabel) {
        console.log(key)
        if (key === 'phoneNo') {
          if (this.form.phoneNo === '' || !isPoneAvailable(this.form.phoneNo)) {
            flag = false
            this.$message.warning('请填写正确格式的手机号码')
            break
          }
        } else if (key === 'verificationCode') {
          if (this.form.verificationCode === '') {
            flag = false
            this.$message.warning('请填验证码')
            break
          }
        } else if (key === 'enterpriseName') {
          if (this.form.enterpriseName === '') {
            flag = false
            this.$message.warning('请填写企业名称')
            break
          }
        }
      }

      if (this.agreement === false) {
        flag = false
        this.$message.warning('请阅读并同意下方的《隐私政策》，并勾选确认。')
      }
      return flag
    },
    // 倒计时
    countDownStart () {
      this.countDown = 60
      this.countDownTimer = setInterval(() => {
        this.countDown > 0 ? this.countDown-- : this.stopCountDown()
      }, 1000)
    },
    stopCountDown () {
      this.countDown = 0
      if (!this.countDownTimer) return
      clearInterval(this.countDownTimer)
      this.countDownTimer = null
    },
    toPrivacy () {
      console.log('%c隐私协议', 'background-color: green;color: #fff;')
      this.$router.push({
        path: '/privacy'
      })
    }
  }
}
</script>

<style lang="less">
#hm-web{
  .hm-web-footer {
    .volume(@width,@height){
        width: @width;
        height: @height;
    }
    padding: 0;
    .w1200 {
      width: 1200PX;
      margin: 0 auto;
    }
    .trial {
      width: 100%;
      height: 326PX;
      text-align: center;
      padding: 44PX 0;
      background-color: #3c76fc;
      .logo-slogan-img {
        width: auto;
        height: 74PX;
      }
      .trial-button {
        width: 130PX;
        height: 48PX;
        // margin-top: 12PX;
        background-color: transparent;
        color: #fff;
        font-size: 18PX;
        border: 1px solid rgba(255,255,255,1);
      }
      .trial-button:hover{
        background-color: #ffffff;
        color: #3e77ff;
      }
      p {
        margin: 0 auto;
        margin-bottom: 28PX;
        font-size: 16PX;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 24PX;
        font-weight: 400;
      }
      .tryout-box {
        // display: flex;
        // justify-content: center;
        width: 1200PX;
        text-align: center;
        margin: 0 auto;
        .input {
          width: 268PX;
          height: 48PX;
          margin-right: 16PX;
          input {
            height:48PX;
          }
        }
        .company-input {
          width: 432PX;
          height: 48PX;
          margin-right: 16PX;
        }
      }
      .privacy {
        width: 292PX;
        margin-top: 16PX;
        span {
          color: #FFFFFF;
        }
        .link {
          color: #FFFFFF;
        }
      }
    }
    .trial-h5 {
      width: 100%;
      height: 20rem;
      padding-top: 4.75rem;
      text-align: center;
      .logo-slogan-img {
        width: auto;
        height: 4.25rem
      }
      .trial-button {
        display: block;
        margin: 0 auto;
        width: 10rem;
        height: 4rem;
        margin-top: 1.6rem;
        background-color: transparent;
        color: #fff;
        font-size: 1.4rem;
        border-width: .1rem;
        border-radius: .4rem;
      }
      .trial-button:hover{
        background-color: #fff;
        color: #3e77ff;
      }
    }
    .footer {
      background: #292F3A;
      padding-top: 82PX;
      .content {
        // height: 360PX;
        display: flex;
        margin-bottom: 80PX;
        img {
            width: auto;
            height: 48PX;
            margin-bottom: 15PX;
          }
        .right {
          width: 100%;
          // margin-left: 180PX;
          .item {
            display: flex;
            justify-content: flex-end;
            text-align: left;
            .navigation {
              margin-left: 80PX;
              .h1 {
                color: #d8dde6;
                font-weight: bold;
                margin-bottom: 30PX;
                cursor: pointer;
              }
              .li{
                  font-size: 13PX;
                  color: #848D9E;
                  cursor: pointer;
                  margin-top: 20PX;
              }
              .li:hover{
                color: #fff;
              }
              .ulCase {
                width: 180PX;
                li {
                  display: inline-block;
                  width: 65PX;
                  margin-top:0;
                  margin-bottom: 20PX;
                }
                li:nth-child(even) {
                  margin-left: 50PX;
                }
              }
            }
          }
        }
      }
      .content_footer {
        // .linkimg{
        //   padding-top: 20PX;
        //   height: 50PX;
        //   display: flex;
        //   .imgwrap1{
        //     cursor: pointer;
        //     width: 36PX;
        //     height: 36PX;
        //     // margin-right: 21PX;
        //     position: relative;
        //     // margin-left: 51PX;
        //     .img3{
        //       display: none;
        //     }
        //     .code1 {
        //       display: none;
        //     }
        //   }
        // }
        // .imgwrap1:hover{
        //   .img1{
        //     display: none;
        //   }
        //   .img3{
        //     display: block;
        //   }
        //   .code1 {
        //     display: block;
        //     position: absolute;
        //     left: 50%;
        //     top: -10PX;
        //     transform: translate(-50%, -100%);
        //   }
        // }
        // .imgwrap2{
        //   cursor: pointer;
        //   width: 36PX;
        //   height: 36PX;
        //   margin-left: 20PX;
        //   position: relative;
        //   .img4{
        //     display: none;
        //   }
        //   .code2 {
        //     display: none;
        //   }
        // }
        // .imgwrap2:hover{
        //   .img2{
        //     display: none;

        //   }
        //   .img4{
        //     display: block;
        //   }
        //   .code2 {
        //     display: block;
        //     position: absolute;
        //     left: 50%;
        //     top: -10PX;
        //     transform: translate(-50%, -100%);
        //   }
        // }
        .componay_msg {
          margin-top: 24PX;
          font-size: 13PX;
          color: #848D9E;
          line-height: 25PX;
          display: flex;
          justify-content: space-between;
          .address {
            width: 356PX;
          }
          .componay_photo {
            .componay_horn_img {
              width: auto;
              height: 62PX;
              margin-top: 10PX;
            }
            .componay_photo_item {
              height: 66PX;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              font-size: 12PX;
              .footer_icon_03 {
                .volume(30PX, 40PX);
              }
              .footer_icon_04 {
                .volume(48PX, 40PX);
              }
              .footer_icon_05 {
                .volume(54PX, 40PX);
              }
              .footer_icon_06 {
                .volume(56PX, 28PX);
                margin-top: 8PX;
              }
              .footer_icon_07 {
                .volume(40PX, 40PX);
              }
            }
          }
        }
      }
      .line {
        background-color: rgba(60,65,73,1);
        margin-bottom: 12PX;
      }
      .copyright {
        width: 1200PX;
        margin: 0 auto;
        font-size: 12PX;
        color: #848D9E;
        padding-bottom: 100PX;
        display: flex;
        align-items: center;
        .footer_marking {
          .volume(238PX, auto);
          display: inline-block;
          // margin-right: 20PX;
        }
      }
    }
  }
  .linkimg{
    // padding-top: 20PX;
    // height: 50PX;
    display: flex;
    flex: 1;
    justify-content: right;
    .imgwrap1{
      cursor: pointer;
      width: 36PX;
      height: 36PX;
      // margin-right: 21PX;
      position: relative;
      // margin-left: 51PX;
      .img3{
        display: none;
      }
      .code1 {
        display: none;
      }
    }
  }
  .imgwrap1:hover{
    .img1{
      display: none;
    }
    .img3{
      display: block;
    }
    .code1 {
      display: block;
      position: absolute;
      left: 50%;
      top: -10PX;
      transform: translate(-50%, -100%);
    }
  }
  .imgwrap2{
    cursor: pointer;
    width: 36PX;
    height: 36PX;
    margin-left: 20PX;
    position: relative;
    .img4{
      display: none;
    }
    .code2 {
      display: none;
    }
  }
  .imgwrap2:hover{
    .img2{
      display: none;

    }
    .img4{
      display: block;
    }
    .code2 {
      display: block;
      position: absolute;
      left: 50%;
      top: -10PX;
      transform: translate(-50%, -100%);
    }
  }
  .footer-h5 {
    width: 100%;
    // height: 146rem;
    background: #292F3A;
    color: #848D9E;
    padding-top: 3.2rem;
    padding-bottom: 9.35rem;
    .w750 {
      width: 37.5rem;
      margin: 0 auto;
    }
    .line {
      background: #444A57;
      margin: 3.2rem 0;
    }
    .content {
      padding: 0 2rem;
      .item {
        padding-top: 2rem;
        .navigation {
          .h1 {
            font-size: 1.75rem;
            color: #848D9E;
            padding-top: 1.3rem;
          }
          .line {
            margin: 1.6rem 0;
            background: #444A57;
          }
          .ul {
            display: flex;
            flex-wrap: wrap;
            .li {
              width: 9.1rem;
              font-size: 1.3rem;
              color: #AFBCD4;
              margin-bottom: 1.6rem;
            }
          }
        }
      }
    }
    .componay_msg {
      padding: 0 2rem;
      .top {
        display: flex;
        align-items: center;
        .name {
          font-size: 1.3rem;
          margin-left: 1.8rem;
        }
      }
      .msg {
        font-size: 1.3rem;
        margin-top: 2rem;
        .text {
          padding-left: 6.5rem;
          text-indent: -6.5rem;
          line-height: 2.4rem;
        }
      }
    }
    .code_list {
      // width: 20rem;
      margin: 2rem 0;
      display: flex;
      justify-content: center;
      .item {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .componay_photo {
      // margin: 0 auto;
      padding: 0 2rem;
      width: 37.5rem;
      display: flex;
    }
    .componay_text {
      text-align: center;
      font-size: 1.2rem;
      line-height: 2.4rem;
      margin-top: 2.4rem;
      margin-bottom: 1.6rem;
    }
    .copyright {
      display: flex;
      justify-content: center;
    }
  }
}
</style>

<style>
.footer_icon {
    width: 35PX;
    height: 35PX;
    display: inline-block;
    border-radius: 50%;
    margin-right: 20PX;
  }
  /* .footer_h5icon_03 {
    width: 2.2rem;
    height: 2.9rem;
  } */
.footer_logo_01 {
  width: 8.75rem;
  height: 4rem;
}
.footer_h5icon_code {
  width: 8rem;
  height: 8rem;
}
.footer_componay_01_zh {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/layout/footer/index.vue